import { appContext } from "../AppContext";

export class NumberHelper
{
    public static toDiskSize(bytes: number, decimals = 2): string
    {
        const labels = appContext().labels;

        if (bytes === 0) return `0${labels.NumberHelper_Bytes}`;

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = [
            labels.NumberHelper_Bytes,
            labels.NumberHelper_KiloBytes,
            labels.NumberHelper_MegaBytes,
            labels.NumberHelper_GigaBytes,
            labels.NumberHelper_TeraBytes,
        ];
        const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    }
}
